import { useMemo } from 'react'
import { CurrencyAmount, Token } from '@nominex/nomiswap-sdk'
import { useSingleCallResult } from 'state/multicall/hooks'
import { useBep20 } from './useContract'

// returns undefined if input token is undefined, or fails to get token contract,
// or contract total supply cannot be fetched
function useTotalSupply(token?: Token): CurrencyAmount<Token> | undefined {
  const contract = useBep20(token?.address)

  const totalSupply: string | undefined = useSingleCallResult(contract, 'totalSupply')?.result?.[0]?.toString()

  return useMemo(
    () => (token && totalSupply ? CurrencyAmount.fromRawAmount(token, totalSupply) : undefined),
    [token, totalSupply],
  )
}

export default useTotalSupply
